export default "__VITE_ASSET__3ad70f4e__"